import React from "react";

interface Props {
  isChecked: boolean;
  setIsChecked: () => unknown;
}
export const CheckBox = ({ isChecked, setIsChecked }: Props) => {
  return <input type="checkbox" checked={isChecked} onChange={setIsChecked} />;
};
